import React from 'react';
import { FaX } from 'react-icons/fa6';

const PopupWindow = ({ children, setOpen, style, open }) => {
  if (open)
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 999,
          padding: 20,
        }}
        onMouseDown={() => setOpen(false)}
      >
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 999,
          }}
          onMouseDown={() => setOpen(false)}
        >
          <div
            style={{
              background: '#436c9a',
              width: '300px',
              ...style,
              padding: '20px',
              borderRadius: '10px',
              boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
              maxHeight: '75vh',
              overflowY: 'auto',
            }}
            onMouseDown={(e) => e.stopPropagation()} // Prevent closing when clicking inside the popup
          >
            <div
              style={{
                justifyContent: 'flex-end',
                display: 'flex',
                width: '100%',
              }}
              onMouseDown={() => setOpen(false)}
            >
              <FaX />
            </div>
            {children}
          </div>
        </div>
      </div>
    );
};

export default PopupWindow;
